<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">

    <a-spin :spinning="confirmLoading">
<!--      <a-form :form="form">-->
        <a-form-model-item :label="language['legalperson']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="legalpersonList">
          <a-checkbox-group v-model="model.legalpersonList" >
            <a-checkbox v-for="(item, index)  in legalpersonOptions" :key="index" :value="item.value">{{ item.label }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>


<!--      </a-form>-->

    </a-spin>
  </j-modal>
</template>

<script>
  // import pick from 'lodash.pick'
  import { httpAction, getAction } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate.vue';
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'

  export default {
    name: "ApptypeApplicationModal",
    components: {
      JDate,
      JSelectUserByDep
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
        },
        url: {
          edit: "/hhemp/colManager/empcolmanagerLegal",
        },
        colManagerId:"",
        id:"",
        legalpersonOptions:[],
      }
    },
    created () {
      this.initLegalpersonList();
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      appTypeSet(colManagerId){
        this.colManagerId = colManagerId;
        this.id = colManagerId;
        this.edit({colManagerId:this.colManagerId,id:this.id,legalpersonList: '',});

      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.getManagerLegalpersons(this.colManagerId);

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            httpurl+=this.url.edit;
            method = 'post';
            this.model.id = this.id;
            this.model.colManagerId = this.colManagerId;
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                //this.init();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
              that.submitCallback();
            })



          }
        })
      },
      handleCancel () {
        this.close()
      },
      submitCallback(){
        this.$emit('ok');
        this.close();
      },
      initLegalpersonList(){
        getAction("/hhemp/emplegalpersoncompany/allListByEntranceCode",{entranceCode:this.$store.getters.application.applicationCode,legalType:'legal1'}).then((res)=>{
          if(res.success){
            this.legalpersonOptions = res.result.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value:item.id}
              return c;
            })
          }
        })
      },
      getManagerLegalpersons(colManagerId){
        getAction("/hhemp/colManagerLegal/getLegalpersonIdsByColManagerId",{colManagerId:colManagerId}).then((res)=>{
          if(res.success){
            this.model.legalpersonList = res.result;
            this.legalpersonList = res.result;
            this.$forceUpdate();
          }
        })
      },
      /*handleChangeLegalperson(event) {
        debugger
        this.legalpersonList = event;
        this.model.legalpersonList = event;
      },*/
    }
  }
</script>

<style scoped>

</style>